import { Search, X } from 'lucide-react';

/**
 * Reusable search input with icon and optional clear button
 */
export default function SearchBar({
  value,
  onChange,
  placeholder = 'Search…',
  className = '',
  inputClassName = 'rounded-lg',
  clearable = true,
}) {
  return (
    <div className={`relative ${className}`}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`w-full border border-slate-200 pl-9 pr-8 h-[35px] text-[13px] text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-brand-blue/30 focus:border-brand-blue transition-all bg-white ${inputClassName}`}
      />
      <Search size={15} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
      {clearable && value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 p-0.5 rounded transition-colors cursor-pointer"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}




